<template>
    <div class="tab-pane fade show active position-relative" id="details" role="tabpanel" aria-labelledby="details-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle></product-lang-toggle>
            <form action="">
                <div class="form-element-container">
                    <div v-for="(group, idx) in generalDetails.items" :key="idx">
                        <div class="row">
                            <div class="col-md-12 clearfix">
                                <h3>{{group.groupingName}}</h3>
                            </div>
                        </div>
                        <div class="row ml-0 d-flex flex-column">
                            <div class="d-flex flex-column mb-2" v-for="(groupItem, groupItemIdx) in group.groupItems" :key="groupItem.label">
                                <div :key="'label_' + groupItemIdx">
                                    <label class="edit-in-place-label text-truncate">{{groupItem.label}}:</label>
                                </div>
                                <div class="pb-2" :key="'field_' + groupItemIdx">
                                    <generic-tooltip v-if="groupItem.type == 'text' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            slot="tooltip_sibling"
                                            type="short-text"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'text' && !groupItem.tooltip">
                                        <edit-in-place
                                            type="short-text"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>

                                    <generic-tooltip v-if="groupItem.type == 'textarea' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            v-if="groupItem.type == 'textarea'"
                                            slot="tooltip_sibling"
                                            type="long-text"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'textarea' && !groupItem.tooltip">
                                        <edit-in-place
                                            type="long-text"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>

                                    <generic-tooltip v-if="groupItem.type == 'wysiwyg' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            v-if="groupItem.type == 'wysiwyg'"
                                            slot="tooltip_sibling"
                                            type="html"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'wysiwyg' && !groupItem.tooltip">
                                        <edit-in-place
                                            type="html"
                                            :is-master="isMaster"
                                            :master-value="groupItem.master_value"
                                            :propertyValue="groupItem.value"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>
                                    
                                    <generic-tooltip v-if="groupItem.type == 'select' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            v-if="groupItem.type == 'select'"
                                            slot="tooltip_sibling"
                                            type="single-select"
                                            :is-master="isMaster"
                                            :master-value="singleSelectValueSanitized(groupItem.master_value, groupItem.options)"
                                            :propertyValue="singleSelectValueSanitized(groupItem.value, groupItem.options)"
                                            :options="singleSelectOptionsSanitized(groupItem.options)"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'select' && !groupItem.tooltip">
                                        <edit-in-place
                                            v-if="groupItem.type == 'select'"
                                            type="single-select"
                                            :is-master="isMaster"
                                            :master-value="singleSelectValueSanitized(groupItem.master_value, groupItem.options)"
                                            :propertyValue="singleSelectValueSanitized(groupItem.value, groupItem.options)"
                                            :options="singleSelectOptionsSanitized(groupItem.options)"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>

                                    <generic-tooltip v-if="groupItem.type == 'checkbox' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            type="single-select"
                                            slot="tooltip_sibling"
                                            :is-master="isMaster"
                                            :master-value="checkboxValueSanitized(groupItem.master_value)"
                                            :propertyValue="checkboxValueSanitized(groupItem.value)"
                                            :options="checkboxOptions"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'checkbox' && !groupItem.tooltip">
                                        <edit-in-place
                                            type="single-select"
                                            :is-master="isMaster"
                                            :master-value="checkboxValueSanitized(groupItem.master_value)"
                                            :propertyValue="checkboxValueSanitized(groupItem.value)"
                                            :options="checkboxOptions"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>

                                    <generic-tooltip v-if="groupItem.type == 'multiselect' && groupItem.tooltip && groupItem.tooltip.length" :message="groupItem.tooltip" :position="'top'">
                                        <edit-in-place
                                            type="multi-select"
                                            slot="tooltip_sibling"
                                            :is-master="isMaster"
                                            :master-value="multiSelectValueSanitized(groupItem.master_value)"
                                            :propertyValue="multiSelectValueSanitized(groupItem.value)"
                                            :options="groupItem.options"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                        <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                            <i class="fas fa-info-circle"></i>
                                        </span>
                                    </generic-tooltip>
                                    <div class="mr-3" v-if="groupItem.type == 'multiselect' && !groupItem.tooltip">
                                        <edit-in-place
                                            type="multi-select"
                                            :is-master="isMaster"
                                            :master-value="multiSelectValueSanitized(groupItem.master_value)"
                                            :propertyValue="multiSelectValueSanitized(groupItem.value)"
                                            :options="groupItem.options"
                                            :show-save-and-sync="true"
                                            :read-only="readOnlyValueSanitized(groupItem.disabled)"
                                            :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                            <api-handler
                                                @success="(value) => handleApiSuccess(groupItem.name, idx, value)"
                                                :product-id="$parent.product.info.id"
                                                :version-id="generalDetails.activeLanguageId"
                                                :type="group.groupingName"
                                                :name="groupItem.name">
                                            </api-handler>
                                        </edit-in-place>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-crud-controls">
                            <a href="/products" class="btn btn-info">Go back</a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'

    import GenericTooltip from "../generic/generic-tooltip.vue";
    import productLangToggle from './product-language-select.vue';
    import EditInPlace from '../edit-in-place/edit-in-place.vue';
    import ProductDetailGeneralApiHandler from './product-details-general-api-handler.vue';

    Vue.use(VueEvents)

    export default {
        name: 'product-general',
        props: ['generalDetails'],
        components:{
            'product-lang-toggle': productLangToggle,
            'edit-in-place': EditInPlace,
            'api-handler': ProductDetailGeneralApiHandler,
            'generic-tooltip': GenericTooltip
        },
        mounted() {},
        created() {},
        watch: {},
        data() {
            return {
                uiStates: {
                    errorMessage: null,
                    showLoading: false,
                },
            }
        },
        computed: {
            isMaster() {
                return (this.generalDetails.activeLanguageId === "0");
            },
            checkboxOptions() {
                return [
                    {value: "0", label: 'No'},
                    {value: "1", label: 'Yes'},
                ]
            },
            hasScheduleFeature() {
                return this.$parent.featureAllowed('scheduled_content');
            },
            hasSchedulePermission() {
                return this.$parent.permissionAllowed('schedule_content');
            }
        },
        methods: {
            multiSelectValueSanitized(selectedValue) {
                if (selectedValue == null || selectedValue == undefined) {
                    return [];
                }
                return selectedValue;
            },
            singleSelectValueSanitized(selectedValue, options) {
                let selectOption = options.filter((option) => {
                    return option.id == selectedValue;
                });
                if (selectOption.length == 0) {
                    return '';
                }
                return selectOption[0].id;
            },
            singleSelectOptionsSanitized(options) {
                return options.map((option) => {
                    return {
                        value: option.id,
                        label: option.name
                    }
                })

            },
            checkboxValueSanitized(selectedValue) {
                if (selectedValue == null || selectedValue == undefined) {
                    return null;
                }
                return selectedValue + '';
            },
            readOnlyValueSanitized(value) {
                if (value == null || value == undefined) {
                    return false;
                }
                return value;
            },
            handleApiSuccess(updatedField, index, updatedValue) {

                const itemToUpdate = 
                    this.$parent.generalDetails.items[index].groupItems.find((field) => {
                        return field.name === updatedField
                    });

                itemToUpdate.value = updatedValue;
            }
        },
    };
</script>

<style scoped lang="scss">
    .vue-loader-small{
        background-color: transparent;
        text-align: right;
        padding-top: 6px;
        padding-right: 10px;
    }

    .vue-details-loader{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        z-index: 12;
        text-align: right;
        padding: 5px 10px;
    }
</style>